var render = function (_h,_vm) {var _c=_vm._c;return _c('v-progress-linear',{staticClass:"ma-0 pa-0",attrs:{"indeterminate":_vm.props.value,"background-opacity":"0","color":"accent","height":"2"}})}
var staticRenderFns = []

export { render, staticRenderFns }